<template>
  <v-select
    dense
    outlined
    clearable
    hide-details="auto"
    v-model="local_value"
    :items="ehr_section_items"
    :label="label"
    :readonly="readonly"
  ></v-select>
</template>

<script>
import ehrSectionItems from '@/script/department/ehr-section-items';

export default {
    props: {
        value: Number,
        label: String,
        readonly: Boolean
    },
    data() {
        return {
			local_value: null,
            ehr_section_items: ehrSectionItems
        };
    },
    mounted() {
        this.local_value = this.value;
    },
	watch: {
		value(val) {
			this.local_value = val;
		},
		local_value(val) {
			this.handleInput();
		}
	},
	methods: {
		handleInput() {
            this.$emit('input', this.local_value);
        }
	}
};
</script>

<style>
</style>